var _rect, _g, _circle, _circle2, _path, _circle3, _circle4, _circle5, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSignInBgIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 737,
    height: 1024,
    viewBox: "0 0 737 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 1,
    width: 737,
    height: 1024,
    fill: "#3876BB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_2_25",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M627.477 68L669.222 110.942C645.259 134.236 607.173 134.065 583.419 110.83L627.477 68Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M669.222 110.942L671.014 109.199L672.757 110.992L670.964 112.734L669.222 110.942ZM627.477 68L625.734 66.2074L627.527 64.4648L629.269 66.2574L627.477 68ZM583.419 110.83L581.671 112.617L579.838 110.824L581.676 109.037L583.419 110.83ZM667.429 112.684L625.684 69.7426L629.269 66.2574L671.014 109.199L667.429 112.684ZM585.167 109.043C607.954 131.332 644.491 131.496 667.479 109.149L670.964 112.734C646.027 136.976 606.392 136.798 581.671 112.617L585.167 109.043ZM581.676 109.037L625.734 66.2074L629.219 69.7926L585.162 112.623L581.676 109.037Z",
    fill: "white",
    mask: "url(#path-2-inside-1_2_25)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 355,
    cy: -30,
    r: 96,
    fill: "#8EE0C6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 744.414,
    cy: 311,
    r: 93.5,
    stroke: "#8EE0C6",
    strokeWidth: 33
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-29.872 58.9995L48.7383 83.2558C48.7382 83.2561 48.7381 83.2565 48.738 83.2569C42.0398 104.965 19.0123 117.132 -2.69532 110.434C-24.403 103.736 -36.5705 80.7083 -29.8723 59.0006C-29.8722 59.0002 -29.8721 58.9999 -29.872 58.9995Z",
    fill: "#8EE0C6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 222.5,
    cy: 1056.5,
    r: 99,
    stroke: "#8EE0C6",
    strokeWidth: 33
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 2,
    cy: 474,
    r: 23.75,
    stroke: "white",
    strokeWidth: 2.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: -22.7062,
    cy: 948.293,
    r: 52.4276,
    transform: "rotate(-60.9378 -22.7062 948.293)",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-10-inside-2_2_25",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M287.812 311.23L228.133 316.235C225.341 282.933 249.647 253.609 282.678 250L287.812 311.23Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M228.133 316.235L228.342 318.726L225.851 318.935L225.642 316.444L228.133 316.235ZM287.812 311.23L290.304 311.022L290.513 313.513L288.021 313.722L287.812 311.23ZM282.678 250L282.407 247.515L284.955 247.237L285.169 249.792L282.678 250ZM227.925 313.744L287.604 308.739L288.021 313.722L228.342 318.726L227.925 313.744ZM282.95 252.486C251.263 255.948 227.946 284.079 230.625 316.026L225.642 316.444C222.736 281.787 248.03 251.271 282.407 247.515L282.95 252.486ZM285.169 249.792L290.304 311.022L285.321 311.439L280.187 250.209L285.169 249.792Z",
    fill: "white",
    mask: "url(#path-10-inside-2_2_25)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignInBgIcon);
export default __webpack_public_path__ + "static/media/SignInBgIcon.89c966246fa6f3a477149d89484686ef.svg";
export { ForwardRef as ReactComponent };